// A space's Knowledge tab, after Space3: the space's folders, then "From the team" (the Team-wide folders the
// assistant also uses for this space), with New folder in this space.
import { AddLink } from '../ui/AddButton';
import { Link } from 'react-router-dom';
import { can, type SessionUser, type SpaceDetail } from '@dpw/shared';
import { Skel } from '../ui/motion';
import { useFolders } from './hooks';
import { FolderCard, useSpaceColors } from './parts';

export function SpaceKnowledge({ s, me }: { s: SpaceDetail; me: SessionUser }) {
  const folders = useFolders();
  const colors = useSpaceColors();
  const all = folders.data ?? [];
  const mine = all.filter(f => f.spaceId === s.id);
  const team = all.filter(f => !f.spaceId);
  return (
    <div className="kb knw" role="tabpanel" aria-label="Knowledge">
      <div className="ctxh"><div className="tl"><b>{s.name} folders</b><span>Documents for this engagement. When you ask about {s.name}, the assistant reads these folders and the Team-wide ones, and cites the file and page.</span></div>
        {can(me.role, 'file.write') && <AddLink to={`/folders?new=${s.id}`}>New folder</AddLink>}</div>
      {folders.isLoading ? <div className="fgrid">{[0, 1, 2].map(i => <div key={i} className="fcard"><Skel w="40%" h={14} /><Skel w="70%" h={18} /><Skel h={12} /></div>)}</div> : (
        <div className="fgrid">{mine.map(f => <FolderCard key={f.id} f={f} colors={colors} />)}</div>
      )}
      {!folders.isLoading && !mine.length && <div className="panel sm mut">No folders in {s.name} yet.</div>}
      <div className="knsub"><b>From the team</b><span>Team-wide folders the assistant also uses for {s.name}</span><Link className="xs mut" to="/folders" style={{ marginLeft: 'auto' }}>All folders in the Knowledge base</Link></div>
      <div className="fgrid">{team.map(f => <FolderCard key={f.id} f={f} colors={colors} />)}</div>
    </div>
  );
}
